import * as financialActions from 'actions/financial';

const initialState = {
  fetchingPayouts: false,
  payoutsFetched: false,
  payoutList: [],
  uploadedFileContents: null,
  uploadingFile: false,
  fileUploadError: null,
  fetchingConnectedAccount: false,
  connectedAccount: null,
  connectedAccountError: null,
  updatingFinancialDetails: false,
  updateFinancialDetailsError: null,
  modifyingSource: false,
  modifyingSourceError: null,
  fetchingSource: false,
  fetchingSourceError: null,
  subscriptionDetails: null,
};

const financialReducer = (state = initialState, action) => {
  switch (action.type) {
    case financialActions.REQUEST_PAYOUTS:
      return { ...state, ...action.payload };
    case financialActions.SET_PAYOUT_LIST:
      return { ...state, ...action.payload };
    case financialActions.REQUEST_PAYOUT_TRANSACTIONS:
      return { ...state, ...action.payload };
    case financialActions.SET_PAYOUT_TRANSACTIONS_LIST:
      return { ...state, ...action.payload };
    case financialActions.REQUEST_STRIPE_FILE_UPLOAD:
      return { ...state, ...action.payload };
    case financialActions.SET_UPLOADED_STRIPE_FILE:
      return { ...state, ...action.payload };
    case financialActions.REQUEST_CONNECTED_ACCOUNT_DETAILS:
      return { ...state, ...action.payload };
    case financialActions.SET_CONNECTED_ACCOUNT_DETAILS:
      return { ...state, ...action.payload };
    case financialActions.REQUEST_UPDATE_FINANCIAL_DETAILS:
      return { ...state, ...action.payload };
    case financialActions.FINANCIAL_DETAILS_UPDATED:
      return { ...state, ...action.payload };
    case financialActions.REQUEST_MODIFY_SOURCE:
      return { ...state, ...action.payload };
    case financialActions.DID_MODIFY_SOURCE:
      return { ...state, ...action.payload };
    case financialActions.REQUEST_FETCH_SUBSCRIPTION_SOURCE:
      return { ...state, ...action.payload };
    case financialActions.DID_FETCH_SUBSCRIPTION_SOURCE:
      return { ...state, ...action.payload };
    case financialActions.CLEAR_SUBSCRIPTION_SOURCES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default financialReducer;



// WEBPACK FOOTER //
// ./src/reducers/financial/index.js